import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import React from 'react';
import { CartItemProps } from 'stores/cart-context';
import './CartItem.css';

interface Props {
  item: CartItemProps;
  onAdd: () => void;
  onRemove: () => void;
};

const CartItem: React.FC<Props> = ({ item, onAdd, onRemove }) => {
  const formatPrice = (item.price * item.amount).toLocaleString('it-IT');

  return (
    <li className="cart-item">
      <h3 className="cart-item__name">{item.name}</h3>
      <div className="cart-item__info">
        <div className="cart-item__amount">
          <button className="cart-item__btn btn-minus" type="button" onClick={onRemove}><MinusOutlined /></button>
          <span className="cart-item__qty">x{item.amount}</span>
          <button className="cart-item__btn btn-plus" type="button" onClick={onAdd}><PlusOutlined /></button>
        </div>
        <div className="cart-item__price">{formatPrice} Đ</div>
      </div>
    </li>
  )
}

export default CartItem